import React, {Fragment} from "react";
import PropTypes from "prop-types";
import FuxOffsetPaginator from "../../../../../components/BaseComponents/FuxOffsetPaginator/FuxOffsetPaginator";
import {ModuloHRAPI} from "../../../../../api/ModuloHR/ModuloHRAPI";
import TimeoffPaySlipListItem from "./TimeoffPaySlipListItem";
import {BookizonAppManager} from "../../../../../index";
import APIConfig from "../../../../../api/APIConfig";
import AuthAPI from "../../../../../api/AuthAPI";
import ModalPortalHOC from "../../../../../components/BaseComponents/ModalPortalHOC";
import TimeoffPaySlipSignatureModal from "./TimeoffPaySlipSignatureModal";

export default class TimeoffRequestsBustePagaTab extends React.Component {
    constructor(props) {
        super(props);
        this.currentYear = new Date().getFullYear();
        const defaultStaffId = this.getDefaultStaffId(props.staffList);
        this.state = {
            selectedYear: this.currentYear,
            selectedStaffId: defaultStaffId,
            signaturePaySlip: null
        };
        this.paginatorRef = React.createRef();
    }

    getDefaultStaffId = staffList => {
        if (!staffList || !staffList.length) return null;
        return staffList[0].id_dipendente || null;
    }

    getStaffById = staffId => {
        if (!staffId) return null;
        return (this.props.staffList || []).find(s => String(s.id_dipendente) === String(staffId));
    }

    getAvailableYears = _ => {
        const years = [];
        for (let i = 0; i < 5; i += 1) {
            years.push(this.currentYear - i);
        }
        return years;
    }

    buildAttachmentUrl = (path, item) => {
        const staffId = item?.id_dipendente || this.state.selectedStaffId;
        const token = AuthAPI.getUserAccessToken();
        if (!staffId || !item?.pay_slip_id || !token) return null;
        return `${APIConfig.url(path)}?pay_slip_id=${item.pay_slip_id}&id_dipendente=${staffId}&token=${token}`;
    }

    resetPaginator = _ => {
        if (this.paginatorRef.current && this.paginatorRef.current.reset) {
            this.paginatorRef.current.reset();
        }
    }

    handleYearChange = event => {
        const year = parseInt(event.target.value, 10) || this.currentYear;
        this.setState({selectedYear: year}, this.resetPaginator);
    }

    handlePageRequest = page => {
        const staffIds = (this.props.staffList || []).map(staff => staff.id_dipendente).filter(Boolean);
        if (!staffIds.length) {
            return Promise.resolve({data: [], total: 0, max_items: 1, pages: 1, prev: null, next: null});
        }

        return ModuloHRAPI.PaySlips.pagination(staffIds, this.state.selectedYear, page);
    }

    handleOpenPaySlip = item => {
        const url = this.buildAttachmentUrl("/modulo-hr/pay-slips/attachments/pay-slip", item);
        if (url) {
            BookizonAppManager.openInAppBrowser(url);
        }
    }

    handleOpenPayCheck = item => {
        const url = this.buildAttachmentUrl("/modulo-hr/pay-slips/attachments/pay-check", item);
        if (url) {
            BookizonAppManager.openInAppBrowser(url);
        }
    }

    handleOpenSignature = item => {
        this.setState({signaturePaySlip: item});
    }

    handleCloseSignature = _ => {
        this.setState({signaturePaySlip: null});
    }

    handleSigned = _ => {
        this.setState({signaturePaySlip: null}, this.resetPaginator);
    }

    renderItem = (item, index) => {
        const staff = this.getStaffById(item.id_dipendente);
        return (
            <TimeoffPaySlipListItem
                key={item.pay_slip_id || index}
                item={item}
                staff={staff}
                onOpenPaySlip={this.handleOpenPaySlip}
                onOpenPayCheck={this.handleOpenPayCheck}
                onSignPaySlip={this.handleOpenSignature}
            />
        );
    }

    renderEmptyPage = _ => {
        return (
            <div className={"container text-center text-muted py-4"}>
                Non ci sono buste paga per questo anno.
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <div className={"container pt-3 pb-4"}>
                    <div className={"input-group mb-3"}>
                        <div className={"input-group-prepend"}>
                            <span className={"input-group-text"}>Seleziona anno</span>
                        </div>
                        <select
                            className={"form-control"}
                            value={this.state.selectedYear}
                            onChange={this.handleYearChange}
                        >
                            {
                                this.getAvailableYears().map(year => {
                                    return (
                                        <option key={year} value={year}>{year}</option>
                                    );
                                })
                            }
                        </select>
                    </div>

                    <FuxOffsetPaginator
                        ref={this.paginatorRef}
                        onPageRequest={this.handlePageRequest}
                        onItemRender={this.renderItem}
                        onEmptyPage={this.renderEmptyPage}
                        classItemsContainer={"list-group"}
                        visiblePagesCount={5}
                    />
                </div>
                <ModalPortalHOC>
                    {
                        this.state.signaturePaySlip &&
                        <TimeoffPaySlipSignatureModal
                            active={!!this.state.signaturePaySlip}
                            paySlip={this.state.signaturePaySlip}
                            onDismiss={this.handleCloseSignature}
                            onSigned={this.handleSigned}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        );
    }
}

TimeoffRequestsBustePagaTab.propTypes = {
    staffList: PropTypes.array
};
